import { OrangeBookJsEnv } from "./orange_book_js_env";

export class OrangeBook {
  constructor(private model: OrangeBookJsEnv) {
    this.model = { ...model };
  }

  getModel(): OrangeBookJsEnv {
    return {
      ...this.model
    };
  }

  update(model: OrangeBookJsEnv) {
    this.model = model
  }

  updateInputWord(inputWord: string) {
    this.model.inputWord = inputWord;
  }

  setRefineKbn(refineKbn: string) {
    this.model.refineKbn = refineKbn;
  }

  setCallBackKbn(callBackKbn: string) {
    this.model.callBackKbn = callBackKbn;
  }

  setLlCategoryCode(code: string) {
    this.model.llCategoryCode = code;
  }

  setLCategoryCode(code: string) {
    this.model.lCategoryCode = code;
  }
}
